import React from "react";
import { Skeleton } from "@mui/material";

function CardSkeleton() {
  return (
    <div
      style={{
        width: "752px",
        margin: "0 auto",
        background: "var(--color-primitives-white-white)",
        border: "1px solid var(--color-border-primary)",
        borderRadius: "8px",
        overflow: "hidden",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "13px 18px",
          borderBottom: "1px solid var(--color-border-primary)",
        }}
      >
        <div style={{ display: "flex", flexDirection: "column", gap: "4px", flex: 1 }}>
          <Skeleton variant="text" width={100} height={20} />
          <Skeleton variant="text" width={150} height={32} />
        </div>
        <div style={{ display: "flex", gap: "8px" }}>
          <Skeleton variant="rounded" width={100} height={36} />
          <Skeleton variant="rounded" width={100} height={36} />
        </div>
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "10px 18px",
          background: "var(--color-brand-primary-grey-50)",
        }}
      >
        <div style={{ display: "flex", gap: "11px" }}>
          <Skeleton variant="text" width={80} height={20} />
          <Skeleton variant="text" width={80} height={20} />
          <Skeleton variant="text" width={80} height={20} />
        </div>
        <Skeleton variant="text" width={120} height={20} />
      </div>
    </div>
  );
}

export default CardSkeleton;
